export const validation = {
  query: "Your query is required",
  message :"Message is required",
  reportCategory:"Report Category is required",
  reportReason: "Report reason required"
};
